<template>
    <div
        class="chat-window d-flex flex-column justify-content-between h-100"
        :class="elClass"
    >
        <div v-if="currentGroupNotification" class="alert alert-light alert-group-notification" role="alert">
            <span class="badge badge-danger">置顶</span> {{ currentGroupNotification }}
        </div>
        <vue-alert></vue-alert>
        <current-conversation />
    </div>
</template>

<script>
import { ProfileService } from "../services/ProfileService";
import CurrentConversation from "./customcom/current-conversation";
import { translateGroupSystemNotice } from "./utils/common";
import { mapState } from "vuex";

export default {
    name: "ChatRoom",

    components: {
        CurrentConversation
    },

    computed: {
        ...mapState({
            currentUserProfile: state => state.user.currentUserProfile,
            currentConversation: state => state.conversation.currentConversation,
            isLogin: state => state.user.isLogin,
            isSDKReady: state => state.user.isSDKReady,
            isBusy: state => state.video.isBusy,
            userID: state => state.user.userID,
            notification: state => state.notification,
            currentGroupNotification: state => state.group.currentGroupNotification
        })
    },

    watch: {
        notification(next) {
            this.$alert.show(next);
        }
    },

    props: {
        elClass: {
            type: [String, Object]
        }
    },

    data() {
        return {
            profileService: null,
            inputPlaceholder: "开始聊天...",
            inputActive: false,
            room: null,
            messages: [],
            userlists: [],
            showUserBtn: false,
            user: null
        };
    },

    mounted() {
        this.profileService = new ProfileService();
        // 初始化监听器

        this.profileService.hub().$on("init-chat-room", e => {
            this.showUserBtn = e.showUserBtn;
            this.room = e.room;

            this.profileService
                .sig()
                .then(resp => {
                    const data = resp.data;

                    this.user = data.user;
                    this.$store.commit("updateCurrentSiteUser", this.user);

                    this.initListener();
                    this.login({
                        userId: this.user.imId,
                        sig: data.sig,
                        appid: data.sdkappid
                    });

                    this.$emit("show-chat-tab");
                })
                .catch(err => {
                    console.log(err.resp);
                });
        });

        this.profileService.hub().$on("close-chat-room", e => {
            this.leave(e.room);
        });
    },

    methods: {
        login(data) {
            this.tim
                .login({
                    userID: data.userId,
                    userSig: data.sig
                })
                .then(() => {
                    this.$store.commit("toggleIsLogin", true);
                    this.$store.commit("startComputeCurrent");
                    this.$store.commit({
                        type: "GET_USER_INFO",
                        userID: data.userId,
                        userSig: data.sig,
                        sdkAppID: data.appid
                    });
                    //   this.$store.commit('showMessage', {
                    //     type: 'success',
                    //     message: '登录成功'
                    //   })
                })
                .catch(error => {
                    this.$store.commit("showMessage", {
                        message: "登录失败：" + error.message,
                        type: "error"
                    });
                });
        },

        initListener() {
            // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
            this.tim.on(
                this.TIM.EVENT.SDK_READY,
                this.onReadyStateUpdate,
                this
            );
            // SDK NOT READT
            this.tim.on(
                this.TIM.EVENT.SDK_NOT_READY,
                this.onReadyStateUpdate,
                this
            );
            // 被踢出
            this.tim.on(this.TIM.EVENT.KICKED_OUT, this.onKickOut);
            // SDK内部出错
            this.tim.on(this.TIM.EVENT.ERROR, this.onError);
            // 收到新消息
            this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
            // 会话列表更新
            this.tim.on(
                this.TIM.EVENT.CONVERSATION_LIST_UPDATED,
                this.onUpdateConversationList
            );
            // 群组列表更新
            this.tim.on(
                this.TIM.EVENT.GROUP_LIST_UPDATED,
                this.onUpdateGroupList
            );
            // 收到新的群系统通知
            this.tim.on(
                this.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED,
                this.onReceiveGroupSystemNotice
            );
        },
        onReceiveMessage({ data: messageList }) {
            //   this.handleVideoMessage(messageList);
            // console.log(messageList);
            this.handleAt(messageList);
            this.handleGroupNotification(messageList);
            this.handleQuitGroupTip(messageList);
            this.$store.commit("pushCurrentMessageList", messageList);
        },
        onError({ data }) {
            if (data.message !== "Network Error") {
                this.$store.commit("showMessage", {
                    message: data.message,
                    type: "error"
                });
            }
        },
        onReadyStateUpdate({ name }) {
            const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false;
            this.$store.commit("toggleIsSDKReady", isSDKReady);

            if (isSDKReady) {
                this.tim
                    .getMyProfile()
                    .then(({ data }) => {
                        this.$store.commit("updateCurrentUserProfile", data);
                        this.$store.dispatch("syncUserProfile", {
                            nick: this.user.name,
                            // avatar: this.user.imageUrl,
                            profileCustomField: [
                                {
                                    key: "Tag_Profile_Custom_Realname",
                                    value: this.user.realname
                                },
                                {
                                    key: "Tag_Profile_Custom_Work",
                                    value: this.user.workplace
                                }
                            ]
                        });
                    })
                    .catch(error => {
                        this.$store.commit("showMessage", {
                            type: "error",
                            message: error.message
                        });
                    });
                // this.$store.dispatch("getBlacklist");
                this.$store.commit("updateCurrentRoom", this.room);
                this.$store.dispatch("joinGroup", this.room.imId);
            }
        },
        kickedOutReason(type) {
            switch (type) {
                case this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
                    // return "由于多实例登录";
                    return "您已在其他设备登录，";
                case this.TIM.TYPES.KICKED_OUT_MULT_DEVICE:
                    // return "由于多设备登录";
                    return "您已在其他设备登录，";
                case this.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
                    // return "由于 userSig 过期";
                    return "您的会话已过期，";
                default:
                    return "";
            }
        },
        onKickOut(event) {
            this.$store.commit("showMessage", {
                message: `${this.kickedOutReason(
                    event.data.type
                )}重新登录请刷新。`,
                type: "error"
            });
            this.$store.commit("toggleIsLogin", false);
            this.$store.commit("reset");
        },
        onUpdateConversationList(event) {
            this.$store.commit("updateConversationList", event.data);
        },
        onUpdateGroupList(event) {
            this.$store.commit("updateGroupList", event.data);
        },
        onReceiveGroupSystemNotice(event) {
            const isKickedout = event.data.type === 4;
            const isCurrentConversation =
                `GROUP${event.data.message.payload.groupProfile.groupID}` ===
                this.currentConversation.conversationID;
            // 在当前会话被踢，需reset当前会话
            if (isKickedout && isCurrentConversation) {
                this.$store.commit("resetCurrentConversation");
            }

            isCurrentConversation && this.$store.commit("showNotification", {
                //   title: "系统通知",
                message: translateGroupSystemNotice(event.data.message),
                duration: 2000
                // onClick: () => {
                //   const SystemConversationID = "@TIM#SYSTEM";
                //   this.$store.dispatch("checkoutConversation", SystemConversationID);
                // }
            });
        },
        /**
         * 处理 @ 我的消息
         * @param {Message[]} messageList
         */
        handleAt(messageList) {
            // 筛选有 @ 符号的文本消息
            const atTextMessageList = messageList.filter(
                message =>
                    message.type === this.TIM.TYPES.MSG_TEXT &&
                    message.payload.text.includes("@")
            );
            for (let i = 0; i < atTextMessageList.length; i++) {
                const message = atTextMessageList[i];
                const matched = message.payload.text.match(/@\w+/g);
                if (!matched) {
                    continue;
                }
                // @ 我的
                if (matched.includes(`@${this.currentUserProfile.userID}`)) {
                    // 当前页面不可见时，调用window.Notification接口，系统级别通知。
                    if (this.$store.getters.hidden) {
                        this.notifyMe(message);
                    }
                    this.$store.commit("showNotification", {
                        title: `有人在群${message.conversationID.slice(
                            5
                        )}提到了你`,
                        message: message.payload.text,
                        duration: 3000
                        // onClick: () => {
                        //   const SystemConversationID = "@TIM#SYSTEM";
                        //   this.$store.dispatch("checkoutConversation", SystemConversationID);
                        // }
                    });
                    this.$bus.$emit("new-messsage-at-me", {
                        data: { conversationID: message.conversationID }
                    });
                }
            }
        },
        selectConversation(conversationID) {
            if (conversationID !== this.currentConversation.conversationID) {
                this.$store.dispatch("checkoutConversation", conversationID);
            }
        },
        isJsonStr(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        },
        handleVideoMessage(messageList) {
            const videoMessageList = messageList.filter(
                message =>
                    message.type === this.TIM.TYPES.MSG_CUSTOM &&
                    this.isJsonStr(message.payload.data)
            );
            if (videoMessageList.length === 0) return;
            const videoPayload = JSON.parse(videoMessageList[0].payload.data);
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_DIALING) {
                if (this.isBusy) {
                    this.$bus.$emit("busy", videoPayload, videoMessageList[0]);
                    return;
                }
                this.$store.commit("GENERATE_VIDEO_ROOM", videoPayload.room_id);
                this.selectConversation(videoMessageList[0].conversationID); // 切换当前会话页
                if (videoMessageList[0].from !== this.userID) {
                    this.$bus.$emit("isCalled");
                }
            }
            if (
                videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_CANCEL
            ) {
                this.$bus.$emit("missCall");
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_REJECT) {
                this.$bus.$emit("isRefused");
            }
            if (
                videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_TIMEOUT
            ) {
                this.$bus.$emit("missCall");
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ACCEPTED) {
                this.$bus.$emit("isAccept");
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_HANGUP) {
                this.$bus.$emit("isHungUp");
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_LINE_BUSY) {
                this.$bus.$emit("isRefused");
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ERROR) {
                this.$bus.$emit("isRefused");
            }
        },
        /**
         * 使用 window.Notification 进行全局的系统通知
         * @param {Message} message
         */
        notifyMe(message) {
            // 需检测浏览器支持和用户授权
            if (!("Notification" in window)) {
                return;
            } else if (window.Notification.permission === "granted") {
                this.handleNotify(message);
            } else if (window.Notification.permission !== "denied") {
                window.Notification.requestPermission().then(permission => {
                    // 如果用户同意，就可以向他们发送通知
                    if (permission === "granted") {
                        this.handleNotify(message);
                    }
                });
            }
        },

        handleNotify(message) {
            const notification = new window.Notification("有人提到了你", {
                icon:
                    "https://webim-1252463788.file.myqcloud.com/demo/img/logo.dc3be0d4.png",
                body: message.payload.text
            });
            notification.onclick = () => {
                window.focus();
                this.$store.dispatch(
                    "checkoutConversation",
                    message.conversationID
                );
                notification.close();
            };
        },

        handleGroupNotification(messageList) {
            // 筛选出当前会话的profile update groupTip
            const groupTips = messageList.filter(message => {
                return (
                    this.currentConversation.conversationID ===
                        message.conversationID &&
                    message.type === this.TIM.TYPES.MSG_GRP_TIP &&
                    message.payload.operationType === this.TIM.TYPES.GRP_TIP_GRP_PROFILE_UPDATED
                );
            });
            if (groupTips.length > 0) {
                groupTips.forEach(groupTip => {
                    if (groupTip.payload.newGroupProfile && groupTip.payload.newGroupProfile.notification) {
                        this.$store.commit('updateGroupNotification', groupTip.payload.newGroupProfile.notification);
                    }
                });
            }
        },

        /**
         * 收到有群成员退群/被踢出的groupTip时，需要将相关群成员从当前会话的群成员列表中移除
         * @param {Message[]} messageList
         */
        handleQuitGroupTip(messageList) {
            // 筛选出当前会话的退群/被踢群的 groupTip
            const groupTips = messageList.filter(message => {
                return (
                    this.currentConversation.conversationID ===
                        message.conversationID &&
                    message.type === this.TIM.TYPES.MSG_GRP_TIP &&
                    (message.payload.operationType ===
                        this.TIM.TYPES.GRP_TIP_MBR_QUIT ||
                        message.payload.operationType ===
                            this.TIM.TYPES.GRP_TIP_MBR_KICKED_OUT)
                );
            });
            // 清理当前会话的群成员列表
            if (groupTips.length > 0) {
                groupTips.forEach(groupTip => {
                    if (
                        Array.isArray(groupTip.payload.userIDList) ||
                        groupTip.payload.userIDList.length > 0
                    ) {
                        this.$store.commit(
                            "deleteGroupMemberList",
                            groupTip.payload.userIDList
                        );
                    }
                });
            }
        }
    }
};
</script>
